import type { SessionUser } from '@fixflow/shared-types';
import { apiPost } from './client.js';

export interface LoginResponse {
  token: string;
  user: SessionUser;
}

export function login(email: string, password: string) {
  return apiPost<LoginResponse, { email: string; password: string }>('/api/v1/auth/login', {
    email,
    password,
  }).then((res) => res.data);
}

export function switchStore(storeId: string) {
  return apiPost<LoginResponse, { storeId: string }>('/api/v1/auth/switch-store', {
    storeId,
  }).then((res) => res.data);
}
